import React from "react";
import UIButtonClick from "./UIButtonClick";
import { UIButtonProps } from "./UIButton";
import { Link , useHistory , useLocation} from 'react-router-dom';

export interface UIButtonLinkProps extends UIButtonProps {
  to: string
  replace?: boolean;
}

export default UIButtonLink;

function UIButtonLink(props: UIButtonLinkProps) {
  const location = useLocation();
  const history = useHistory();
  // path: 이전 경로, data: 이전 데이터
  const locationState = location.state as { path: string; data: any };

  return (
    <UIButtonClick
      {...props}
      onClick={() => {
        if (props.replace) {
          history.replace(props.to);
        } else {
          history.push(props.to);
        }
      }}
    />
  );
}
